import { camelizeKeys } from '../lib/functions';

export default {
  state: [],
  getters: {
    activityTypes: state => state,
    activityTypeById: state => activityTypeId => state.find(
      activityType => activityType.activityTypeId === activityTypeId,
    ),
  },
  mutations: {
    addActivityTypes(state, payload) {
      state.push(...payload.map(camelizeKeys));
    },
    clearActivityTypes(state) {
      state.length = 0;
    },
  },
  actions: {
    async loadActivityTypes({ commit, state }, payload) {
      if (payload && payload.useCachedValues && state.length) {
        return;
      }

      const res = await this.$container.dao.getActivityTypes();
      const activityTypes = res.data.activity_types;
      commit('clearActivityTypes');
      commit('addActivityTypes', activityTypes);
    },
    clearActivityTypes(context) {
      context.commit('clearActivityTypes');
    },
  },
};
